import planFeatureIconRawString from '../PlanFeatureIcon.graphql'

export const planFeatureIconString = planFeatureIconRawString

export type PlanFeatureIcon = {
  title: string
}

export const isPlanFeatureIcon = (fragment: any): fragment is PlanFeatureIcon =>
  fragment && typeof fragment.title === 'string'
